import { React } from 'react';
import { Link } from 'react-router-dom';

const SubscriptionReport = () => {
    return (
            <div>
                <div className="connection-header">
                    <h3>Subscription List</h3>
                    <div className="filter-wrapper">
                        <Link className="list-filter add-new-btn" to="/subscription/packages">
                            <i class="ri-add-line"></i>
                            <span>Add New</span>
                        </Link>
                    </div>
                </div>
            </div>
    );
}

export default SubscriptionReport;